import React from 'react';
import styled from 'styled-components';
import { Button, Form, Row } from 'antd';
import { Link } from 'react-router-dom';
import { IToken } from 'store/ducks/globalTypes';
import Background from 'assets/img/main/ProgBGImage.jpg';

export const StyledFormItem = styled(Form.Item)<IToken>`
  margin-bottom: ${(props) => `${props.token.margin}px`};

  .ant-input,
  .ant-input-affix-wrapper {
    padding: 16px 14px;
    border-radius: ${(props) => `${props.token.borderRadiusSM}px`};
    background: #ffffff;
  }

  .ant-input-prefix,
  .ant-input-suffix,
  .ant-input-suffix span {
    font-size: 20px;
    color: #757474 !important;
  }

  .ant-col {
    min-width: 100%;

    .ant-form-item-required {
      color: white;
      font-weight: 600;
    }

    .ant-form-item-explain-warning {
      color: white;
      font-weight: 900;
    }
  }
`;

export const ItemsContainer = styled('div')`
  display: flex;
  flex-direction: column;
  justify-content: center;

  .ant-row.ant-form-item-row {
    min-width: 100%;
  }

  .ant-form-item-explain-error {
    font-weight: 600;
  }
  .ant-form-item .ant-form-item-label {
    text-align: initial;
  }
`;

export const BottomSection = styled('div')`
  display: flex;
  flex-direction: column;
  justify-content: center;
  gap: 15px;

  > button {
    align-self: center;
  }
`;

export const StyledButton = styled((props: any) => <Button {...props} />)`
  min-width: 180px;
  width: fit-content;
  margin: auto;
`;

export const StyledLink = styled(Link)<IToken>`
  margin-bottom: 15px;
  flex-direction: column;
  width: 110px;
  text-transform: capitalize;
  align-self: center;
  display: contents;
  flex-wrap: wrap;
  justify-content: center;
  height: fit-content;
  margin-top: 20px;

  p {
    text-align: center;
    margin: 0;
    padding: 0;
    background: ${(props) => props.token.colorPrimary};
    width: max-content;
    margin: auto;
    border-radius: 5px;
  }

  &:hover {
    p {
      background: ${(props) => props.token.colorPrimaryBgHover};
    }
  }

  span {
    text-align: center;
    border-bottom: 1px solid;
    border: none;
  }
`;

export const StyledDisabledButton = styled(Button)`
  margin-bottom: 15px;
  min-width: 205px;
  border-radius: 15px;
`;

export const NavbarLogin = styled(Row)`
  justify-content: space-between;

  @media (max-width: 768px) {
    justify-content: flex-start;
  }

  .ant-col {
    text-align: center;
    align-content: center;

    h1 {
      text-align: start;
      font-size: 2.5rem;
      font-weight: bold;
      margin: 0px;
      letter-spacing: 1.5px;
      line-height: 2 !important;
      color: #fff;

      @media (max-width: 1400px) {
        font-size: 25px;
      }
      @media (max-width: 768px) {
        font-size: 22px;
      }

      @media (max-width: 500px) {
        font-size: 14px;
      }
    }

    p {
      text-align: justify;
      font-size: 1.5rem;
      margin: 0px;
      letter-spacing: 1px;
      line-height: 2 !important;
      color: #9bd3f0;
      font-weight: 600;

      span {
        padding-right: 25px;

        @media (max-width: 1000px) {
          font-size: 18px;
        }

        @media (max-width: 500px) {
          font-size: 12px;
        }
      }
      @media (max-width: 1000px) {
        display: flex;
        flex-direction: column;
      }

      @media (max-width: 768px) {
        line-height: 1.5 !important;
        letter-spacing: normal;
      }
    }
  }

  img {
    width: 136px;
    position: relative;
    top: -23px;
    left: -42px;

    @media (max-width: 768px) {
      left: 0;
      width: 111px;
      top: -40px;
    }
  }
`;
export const LoginContainer = styled.div`
  min-height: 100vh;
  background-image: ${() => `url(${Background})`};
  background-repeat: no-repeat;
  background-size: cover;
  margin-left: auto;
  margin-right: auto;
`;

export const FormContainer = styled.div`
  margin: auto;
  margin-top: 80px;
  width: 315px;
  display: flex;
  flex-direction: column;

  @media (max-width: 768px) {
    margin: auto;
  }
`;
